/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProformaIssueFormsDirectEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const proformaIssueFormsDirectEntryPoint: EntryPoint<
	ProformaIssueFormsDirectEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<ProformaIssueFormsDirectEntryPointComponent>(
		/* webpackChunkName: "async-proforma-issue-forms-direct-entrypoint" */ './ProformaJiraIssueFormsDirectWrapper.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
